import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=21e30e85&"
import script from "./KYC.vue?vue&type=script&lang=js&"
export * from "./KYC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports